import { cn } from '@/lib/utils';

function Item({ className, variant = 'default', ...props }: React.ComponentProps<'div'> & { variant?: 'default' | 'muted' }) {
  return (
    <div
      data-slot="item"
      className={cn(
        'flex w-full items-center gap-4 rounded-md border border-transparent px-4 py-3 text-sm',
        variant === 'muted' && 'bg-muted/50',
        className,
      )}
      {...props}
    />
  );
}

function ItemMedia({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="item-media" className={cn('flex shrink-0 items-center justify-center', className)} {...props} />;
}

function ItemContent({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="item-content" className={cn('flex flex-1 flex-col gap-1', className)} {...props} />;
}

function ItemTitle({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="item-title" className={cn('font-medium leading-snug', className)} {...props} />;
}

export { Item, ItemMedia, ItemContent, ItemTitle };
